import {ApiClient, getPermissionsByUserId} from '@hconnect/apiclient'
import {useUserContext} from '@hconnect/login'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'

export const usePermissionsQuery = () => {
  const {loggedUser} = useUserContext()

  const userId = loggedUser?.user_id

  const queryFn = useMemo(
    () => (userId ? () => getPermissionsByUserId(ApiClient.axiosInstance)(userId) : undefined),
    [userId]
  )

  return useQuery({
    queryKey: ['permissions', userId],
    queryFn,
    enabled: Boolean(userId)
  })
}
